import gql from 'graphql-tag';

export const GET_AUDIT_LOGS = gql`
  query getWorkspaceAdminAuditLogsByProjectId($organisationId: String!, $projectId: String!) {
  getWorkspaceAdminAuditLogsByProjectId(
    organisationId: $organisationId,
    projectId: $projectId
  ) {
    projectId
    outputId
    type
    subType
    credits
    paymentStatus
    invoiceId
    description {
      message
    }
    createdBy {
      userId
      firstName
      lastName
      email
    }
    createdAt
    addonsCost{
      billingEntityCode
      cost
    }
    showProjectOutputHistory
  }
}
`;

const getWorkspaceAdminAuditLogsByProjectId = (organisationId) => ({
  query: GET_AUDIT_LOGS,
  module: 'reporting',
  ignoreCache: true,
  buildVariables: ({ projectId }) => ({
    organisationId,
    projectId
  }),
  isSilent: true
});

export default getWorkspaceAdminAuditLogsByProjectId;